import React from 'react';
import {FormControlLabel, Grid, Switch, TextField} from "@mui/material";
import * as Yup from 'yup';
import {useParams} from 'react-router-dom';
import useAuth from "../../../hooks/useAuth";
import GeneralEditor from "../../../components/CrudFrom/GeneralEditor";
import localStrings from "../../../localStrings";
import {getEstablishment, saveFormEstablishment} from "../EstablishmentAddView/EstablishmentCreateUpdateForm";
import {useNavigate} from "react-router";
import {cashpad} from "./Integration";
import TextFieldPassword from "../../../components/TextFieldPassword";


const CashPadIntegration = ({item, saveForm}) => {
    let {establishmentId} = useParams();
    const { currentBrand } = useAuth();
    const navigate = useNavigate();
    const buildFormValues = (item) => {
        return {
            initialValues: {

                cashPadApiUserEmail : item?.cashPadApiUserEmail || '',
                cashPadToken : item?.cashPadToken || '',
                cashPadClientName : item?.cashPadClientName || '',
                cashPadActive : item?.cashPadActive || false,
                cashPadBaseUrl : item?.cashPadBaseUrl || "acr.cashpad.net",
            },
            validationSchema: {
                cashPadApiUserEmail: Yup.string().max(255).required(localStrings.check.fieldRequired),
                cashPadToken: Yup.string().max(255).required(localStrings.check.fieldRequired),
                cashPadClientName: Yup.string().max(255).required(localStrings.check.fieldRequired),
            }
        };
    }



    const getCardContentForm = ({
                                    errors,
                                    handleBlur,
                                    handleChange,
                                    handleSubmit,
                                    isSubmitting,
                                    setFieldValue,
                                    touched,
                                    values
                                }) => {
        return (
            <Grid
                container
                spacing={4}
            >

                <Grid
                    item
                    md={12}
                    xs={12}
                >

                </Grid>

                <Grid
                    item
                    md={12}
                    xs={12}
                >
                    <FormControlLabel
                        // className={classes.formControl}
                        control={(
                            <Switch
                                checked={values.cashPadActive}
                                edge="start"
                                name="direction"
                                onChange={() => {
                                    //alert("change ");
                                    setFieldValue('cashPadActive', !values.cashPadActive)
                                }}
                            />
                        )}
                        label={localStrings.active}
                    />
                </Grid>


                <Grid
                    item
                    md={12}
                    xs={12}
                >
                    <TextField
                        inputProps={{
                            autocomplete:"new-password"
                        }}
                        fullWidth
                        helperText={touched.cashPadApiUserEmail && errors.cashPadApiUserEmail}
                        label={localStrings.cashPadApiUserEmail}
                        name="cashPadApiUserEmail"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        variant="standard"
                        required
                        value={values.cashPadApiUserEmail}/>

                </Grid>

                <Grid
                    item
                    md={12}
                    xs={12}
                >
                    <TextFieldPassword
                        inputProps={{
                            autocomplete:"new-password"
                        }}
                        fullWidth
                        helperText={touched.cashPadToken && errors.cashPadToken}
                        label={localStrings.cashPadToken}
                        name="cashPadToken"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        variant="standard"
                        required
                        value={values.cashPadToken}
                    />
                </Grid>

                <Grid
                    item
                    md={12}
                    xs={12}
                >
                    <TextField
                        inputProps={{
                            autocomplete:"new-password"
                        }}
                        fullWidth
                        helperText={touched.cashPadClientName && errors.cashPadClientName}
                        label={localStrings.cashPadClientName}
                        name="cashPadClientName"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        variant="standard"
                        required
                        value={values.cashPadClientName}

                    />
                </Grid>

                <Grid
                    item
                    md={12}
                    xs={12}
                >
                    <TextField
                        inputProps={{
                            autocomplete:"new-password"
                        }}
                        fullWidth
                        helperText={touched.cashPadBaseUrl && errors.cashPadBaseUrl}
                        label={localStrings.cashPadBaseUrl}
                        name="cashPadBaseUrl"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        variant="standard"
                        required
                        value={values.cashPadBaseUrl}

                    />
                </Grid>

            </Grid>
        );
    }




    return <GeneralEditor getItemFunction={() => getEstablishment(currentBrand().id, establishmentId, true, navigate)}
                          buildFormValues={buildFormValues}
                          getCardContentForm={getCardContentForm}
                          saveForm={(item, values) => saveFormEstablishment(
                              {
                                  ...item,
                                  integrationType: cashpad
                              }, values, true, currentBrand().id, navigate)}
                          applyButton={localStrings.update}
                          messageSuccess={localStrings.notif.establishmentUpdated}
                          // titleForm={localStrings.createEstablishment : localStrings.general}
                          getPathToData={(result) => {
                              return  result.data.getEstablishment;
                          }}
    />
};

export default CashPadIntegration;
